import React from 'react';
import {
  Box,
  CircularProgress,
  IconButton,
  TextField,
  Typography
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { FormElement } from './ComponentTypes';

type LookupDetail = {
  key: string;
  label: string;
  value: string;
};

type LookupIdFieldProps = {
  label: string;
  value: any;
  onChange?: (...event: any[]) => void;
  errors?: { [key: string]: any };
  prop: FormElement;
  lookupId: string;
  setLookupId: (id: string) => void;
  isLoading: boolean;
  notFound: boolean;
  requestError: boolean;
  notFoundMessage: string;
  requestErrorMessage: string;
  lookupDetails?: LookupDetail[];
  onClearValues: () => void;
};

function LookupIdField({
  label,
  value,
  onChange,
  errors,
  prop,
  lookupId,
  setLookupId,
  isLoading,
  notFound,
  requestError,
  notFoundMessage,
  requestErrorMessage,
  lookupDetails,
  onClearValues
}: LookupIdFieldProps) {
  const visibleLookupDetails =
    lookupDetails?.filter(({ value }) => Boolean(value)) ?? [];

  function handleKeyPress(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter' && !prop?.props?.multiline) {
      e.preventDefault();
    }
  }

  function handleWheel(e: any) {
    e.target.blur();
  }

  function handleBlur(e: React.FocusEvent<HTMLInputElement>) {
    if (e.target.value !== lookupId) {
      setLookupId(e.target.value);
    }
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (onChange) {
      onChange(e.target.value);
    }
  }

  return (
    <>
      <TextField
        // multiline components bind this prevent default automatically
        onKeyPress={handleKeyPress}
        value={value}
        onWheel={handleWheel}
        onBlur={handleBlur}
        inputProps={{ min: 0 }}
        multiline={prop?.props?.multiline}
        className="form-dynamic-textfield"
        fullWidth
        label={label}
        type="number"
        onChange={handleChange}
        name={prop.id.toString()}
        error={!!errors?.[prop.id]}
        helperText={errors?.[prop.id]?.message}
      />
      {isLoading && (
        <Box style={{ marginTop: 8 }} display="flex" justifyContent="left">
          <CircularProgress size={24} />
        </Box>
      )}
      {notFound && (
        <Typography variant="body1" color="error">
          {notFoundMessage}
        </Typography>
      )}
      {requestError && (
        <Typography variant="body1" color="error">
          {requestErrorMessage}
        </Typography>
      )}
      {visibleLookupDetails.length > 0 && !notFound && !isLoading && (
        <Box
          style={{ marginTop: 8 }}
          display="flex"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Box>
            {visibleLookupDetails.map(({ key, label, value }) => (
              <Box
                key={key}
                display="flex"
                justifyContent="left"
                alignItems="center"
              >
                <Typography variant="body1" color="textSecondary">
                  {label}
                </Typography>
                <Typography
                  variant="body1"
                  color="primary"
                  style={{ marginLeft: 8 }}
                >
                  {value}
                </Typography>
              </Box>
            ))}
          </Box>
          <IconButton
            onClick={onClearValues}
            size="small"
            style={{ marginLeft: 8 }}
          >
            <ClearIcon />
          </IconButton>
        </Box>
      )}
    </>
  );
}

export { LookupIdField };
